jQuery(document).ready(function($) {
    // Add transition style for smooth rotation
    $('<style>')
        .text('#product-list button svg { transition: transform 0.3s ease; }')
        .appendTo('head');

    // Function to open accordion panel
    function openAccordionPanel($button, $content) {
        const actualHeight = $content.find('div').outerHeight();
        $content.addClass('active').animate({ height: actualHeight }, 300);
        $button.attr('aria-expanded', 'true')
            .find('svg').css('transform', 'rotate(180deg)');
    }

    // Function to close accordion panel
    function closeAccordionPanel($button, $content) {
        $content.animate({ height: 0 }, 300, function() {
            $content.removeClass('active');
        });
        $button.attr('aria-expanded', 'false')
            .find('svg').css('transform', 'rotate(0deg)');
    }

    // Handle click events
    $('#product-list article button').click(function(e) {
        e.preventDefault();
        const $button = $(this);
        const $article = $button.closest('article');
        const $content = $('#' + $button.attr('aria-controls'));
        
        // Close other open accordions first
        const $otherButtons = $('#product-list article button').not($button);
        $otherButtons.each(function() {
            const $otherContent = $('#' + $(this).attr('aria-controls'));
            closeAccordionPanel($(this), $otherContent);
        });
        
        // Toggle current panel
        if ($content.hasClass('active')) {
            closeAccordionPanel($button, $content);
        } else {
            openAccordionPanel($button, $content);
        }
    });

    // Handle keyboard navigation
    $('#product-list article button').keydown(function(e) {
        const $buttons = $('#product-list article button');
        const $current = $(this);
        const index = $buttons.index($current);
        
        switch(e.key) {
            case 'ArrowUp':
            case 'Up':
                e.preventDefault();
                if (index > 0) {
                    $buttons.eq(index - 1).focus();
                }
                break;
                
            case 'ArrowDown':
            case 'Down':
                e.preventDefault();
                if (index < $buttons.length - 1) {
                    $buttons.eq(index + 1).focus();
                }
                break;
                
            case 'Home':
                e.preventDefault();
                $buttons.first().focus();
                break;
                
            case 'End':
                e.preventDefault();
                $buttons.last().focus();
                break;
        }
    });
});
